import EmpAdvancedSelector from './emp-advanced-selector.vue'

EmpAdvancedSelector.install = function (Vue) {
	Vue.component(EmpAdvancedSelector.name, EmpAdvancedSelector);
}

export default EmpAdvancedSelector;